import { nanoid } from 'nanoid';
import { getEcho } from './utils.client';
import { getAccessToken, getSubId } from '@devhacker/shared/features/auth/utils/token';

import { usePusherStore, type TNotification } from '~/store/pusher';

type pushBadgePayload = {
  image?: string;
  content?: string;
  clickHandler?: Function;
  isError?: boolean;
};

let pusherStore: ReturnType<typeof usePusherStore> | null = null;

function getPusherStore() {
  pusherStore ??= usePusherStore();
  return pusherStore;
}

export const connectPrivateChannel = (cb?: Function) => {
  const token = getAccessToken();
  if (!token) return;

  const subId = getSubId(token);
  if (!subId) return;

  getEcho()
    .channel(`pusher_database_private-channel.${subId}`)
    .listen('SocketPrivateEvent', (event: TNotification) => {
      getPusherStore().handleWsEvent(event);
      if (cb) {
        cb(event);
      }
    });
};

export const leavePrivateChannel = () => {
  const token = getAccessToken();
  if (!token) return;

  const subId = getSubId(token);
  if (!subId) return;

  return getEcho().leaveChannel(`pusher_database_private-channel.${subId}`);
};

export const fetchUnviewedNotificationsCount = () => {
  const token = getAccessToken();
  if (!token) return;

  const subId = getSubId(token);
  if (!subId) return;

  return getPusherStore().fetchUnviewedNotificationsCount();
};

export const pushBadge = (payload: pushBadgePayload) => {
  const { image, content, clickHandler, isError } = payload;
  return getPusherStore().pushBadge({
    image,
    content,
    clickHandler,
    id: nanoid(),
    isError,
  });
};

export const pusherResetStore = () => getPusherStore().resetStore();
